// features/licenses/hooks.ts
import { useContext } from "react";
import { StateCtx, ActionsCtx } from "./context";
import type { LicensesState } from "./types";

export const useLicensesState = (): LicensesState => {
  const ctx = useContext(StateCtx);
  if (!ctx) throw new Error("useLicensesState must be used within <LicensesProvider>");
  return ctx;
};

export const useLicensesActions = () => {
  const ctx = useContext(ActionsCtx);
  if (!ctx) throw new Error("useLicensesActions must be used within <LicensesProvider>");
  return ctx;
};
